import { Table, TableProps } from 'antd';
import { Link, createSearchParams } from 'react-router-dom';

import { SerialID } from '../../types';

interface RequestJobPostingTemplateFormat {
  id: SerialID;
  name: string;
}

interface RequestJobPostingTemplateTableProps extends TableProps<RequestJobPostingTemplateFormat> {
  searchParams?: URLSearchParams;
}

const RequestJobPostingTemplateTable = ({
  pagination,
  searchParams,
  ...props
}: RequestJobPostingTemplateTableProps) => {
  return (
    <Table<RequestJobPostingTemplateFormat>
      data-testid="request-job-posting-template-table"
      rowKey="id"
      pagination={{
        showTotal: (total) => {
          return `Total: ${total} modelos`;
        },
        ...pagination,
      }}
      {...props}
    >
      <Table.Column
        key="name"
        title="Nome do modelo"
        dataIndex="name"
        render={(_, record: RequestJobPostingTemplateFormat) => (
          <>
            <Link
              className="ant-typography-link"
              to={{
                pathname: `${record.id}/change`,
                search: createSearchParams(searchParams).toString(),
              }}
            >
              {record.name}
            </Link>
          </>
        )}
      />
    </Table>
  );
};

export default RequestJobPostingTemplateTable;
